/**
 * Validates price input value, used to disallow to put to big and to long value. Examples:
 * 
 * 1 - valid
 * 
 * 1.01 - valid
 * 
 * 22.3 - valid
 * 
 * 112.23 - valid
 * 
 * 999999.99 - valid
 * 
 * 1234567 - invalid
 * @param price 
 * @returns 
 */
export const validateProductPriceEditValue = (price: string): boolean => price === '' || /^(?!\d{7}$)(\d{1,6})?(\.)?(\d{1,2})?$/.test(price);
